import CardRow from "components/card/CardRow";
import ViatorProductCard from "components/card/viator/ViatorProductCard";
import LoadingAnimation from "components/ui/loaders/LoadingAnimation/LoadingAnimation";
import { useEffect, useState } from "react";
import { useInView } from "react-cool-inview";

import {
  filterViatorProductsByDistanceFromBoundingBox,
  filterViatorProductsByDistanceFromCoordinates,
} from "pages/api/external/viator/products/index";
import styles from "./ViatorCardRow.module.scss";

export default function ViatorCardRow({
  searchTerms = [],
  currencyCode = "USD",
  cardRowRef,
  destinationId,
  afterFetch = (items) => {},
  location,
  avgDistanceTolerance = 2,
}) {
  const [viatorData, setViatorData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { ref, inView, observe } = useInView({
    unobserveOnEnter: true,
    threshold: 0.01,
  });

  useEffect(() => {
    if (!inView || !searchTerms?.length || !!viatorData) return;

    setIsLoading(true);

    const productFilters = {
      price: {
        from: 50,
      },
      rating: {
        from: 3,
        to: 5,
      },
    };

    // if (destinationId) {
    //   productFilters.destination = destinationId;
    // }

    (async () => {
      try {
        const viatorResults = [];

        //TODO: Reduce count to 2 and remove destination filtering if Viator's starts working again
        for (const searchTerm of searchTerms) {
          const viatorResponse = await fetch(
            "/api/external/viator/search-freetext",
            {
              method: "POST",
              body: JSON.stringify({
                searchTerm: searchTerm,
                currencyCode,
                count: 2,
                productFilters,
                withDestinationInfo: true,
                withGeocodeInfo: true,
                location,
              }),
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          const viatorResponseData = await viatorResponse.json();

          const matchingDestination = viatorResponseData?.products?.filter(
            (product) => {
              return product?.destinations?.some((destination) => {
                return (
                  destination?.destinationInfo?.viator_destination_id?.toString() ===
                  destinationId?.toString()
                );
              });
            }
          );

          const uniqueProducts = matchingDestination?.filter((product) => {
            return !viatorResults.some((viatorProduct) => {
              return viatorProduct.productCode === product.productCode;
            });
          });

          // const locationCoordinates = {
          //   lat: location?.lat,
          //   lon: location?.lon,
          // };

          const productsInProximityToLocation =
            filterViatorProductsByDistanceFromBoundingBox({
              products: uniqueProducts,
              boundingBox: location?.bounding_box,
              tolerance: 2,
            });

          const product = productsInProximityToLocation?.length
            ? productsInProximityToLocation[0]
            : null;

          if (product) {
            viatorResults.push(product);
          }
        }

        setViatorData(viatorResults);
        afterFetch(viatorResults);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    })();
  }, [inView, currencyCode, searchTerms, destinationId, afterFetch]);

  function generateViatorProductCards(viatorProducts) {
    const viatorProductCards = viatorProducts.map((product) => {
      const viatorCard = (
        <ViatorProductCard
          product={product}
          key={product.productCode}
          cardType="mini"
          isLoaded={true}
        />
      );

      return viatorCard;
    });
    return viatorProductCards;
  }

  return (
    <div ref={observe} className={`${styles.container}`}>
      {inView && (
        <>
          {!!isLoading && <LoadingAnimation></LoadingAnimation>}
          {!!viatorData && !isLoading && (
            <CardRow
              cards={generateViatorProductCards(viatorData)}
              sideScroll="all"
              ref={cardRowRef}
              seeAll={false}
              sideScrollButtons={true}
              scrollAfterCardsCount={1}
              // sectionTitle={"Experiences from Viator"}
              // headingType="h3"
            ></CardRow>
          )}
        </>
      )}
    </div>
  );
}
